module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-14-12d8845c0f64da8e3de919ddcd59c42e.jpg";